export default "__VITE_ASSET__UH4IVCcP__"